// ContactUs.tsx
import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Heading,
  Stack,
  Text,
  Input,
  Textarea,
  Field,
  chakra, // 👈 yeh add karo
} from "@chakra-ui/react";
import Header from "components/reusables/Header/Header";
import Footer from "../Footer/Footer";
import CustomButton from "layouts/CustomButton/CustomButton";

const ContactUs: React.FC = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // const formData = new FormData(e.currentTarget);

    // const payload = {
    //   name: formData.get("name") as string,
    //   mobile: formData.get("mobile") as string,
    //   email: formData.get("email") as string,
    //   notes: formData.get("notes") as string,
    // };

    // console.log("contact-form =>", payload);
  };

  return (
    <>
      <Header />
      <Box bg="bg.canvas" py={{ base: 10, md: 16 }}>
        <Container maxW="6xl">
          <Heading as="h2" size="lg" textAlign="center" mb={10}>
            Contact Us
          </Heading>

          <Grid templateColumns={{ base: "1fr", md: "0.9fr 1.1fr" }} gap={8}>
            {/* LEFT: info section */}
            <Box
              bg="bg.surface"
              borderRadius="2xl"
              boxShadow="md"
              p={{ base: 6, md: 8 }}
            >
              <Stack gap={5}>
                {/* <Box>
                  <Heading as="h3" size="md" mb={2}>
                    CashQuin Information
                  </Heading>
                  <Text fontSize="sm" color="fg.muted">
                    <b>CashQuin</b> is owned by <b>Webtooth Techno LLP</b>. We
                    build secure fintech solutions for bill payments and
                    collections.
                  </Text>
                </Box> */}

                <Box>
                  <Text fontWeight="semibold" mb={1}>
                    Location
                  </Text>
                  <Text fontSize="sm" color="fg.muted">
                    Webtooth Techno LLP <br />
                    Sector-49 Gurugram, Haryana
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="semibold" mb={1}>
                    Email
                  </Text>
                  <Text fontSize="sm" color="fg.muted">
                    connect@cashquin.com
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="semibold" mb={1}>
                    Phone
                  </Text>
                  <Text fontSize="sm" color="fg.muted">
                    +91 9511520346
                  </Text>
                </Box>
              </Stack>
            </Box>

            {/* RIGHT: form section */}
            <chakra.form
              onSubmit={handleSubmit}
              bg="bg.surface"
              borderRadius="2xl"
              boxShadow="md"
              p={{ base: 6, md: 8 }}
            >
              <Heading as="h3" size="md" mb={4}>
                Get in touch
              </Heading>

              <Stack gap={4}>
                <Field.Root required>
                  <Field.Label>Name</Field.Label>
                  <Input name="name" placeholder="Enter your name" />
                </Field.Root>

                <Field.Root required>
                  <Field.Label>Mobile number</Field.Label>
                  <Input
                    name="mobile"
                    type="tel"
                    placeholder="Enter your mobile number"
                  />
                </Field.Root>

                <Field.Root required>
                  <Field.Label>Email address</Field.Label>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                  />
                </Field.Root>

                <Field.Root>
                  <Field.Label>Drop message</Field.Label>
                  <Textarea
                    name="notes"
                    rows={5}
                    placeholder="Write your message / notes here"
                  />
                </Field.Root>
                <Box
                  display="flex"
                  rotate="left" 
                  maxW={"1/3"}
                >
                  <CustomButton
                    type="submit"
                    colorPalette="blue"
                    // size="md"
                    // alignSelf={{ base: "stretch", md: "flex-start" }}
                  >
                    Send Message
                  </CustomButton>
                </Box>
                {/* <Button
                  type="submit"
                  colorPalette="green"
                  size="lg"
                  alignSelf={{ base: "stretch", md: "flex-start" }}
                >
                  Send Message
                </Button> */}
              </Stack>
            </chakra.form>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ContactUs;
